/* eslint-disable */
export default function registerFormElements($, apower) {
  //form
  $.registerComponent("form-fields", {
    template: `<form class="form-fields" :autocomplete="autoComplete ? 'on' : 'off'"><slot></slot></form>`,

    messages: {
      required: apower.tr("This field is required@@field_required"),
      email: apower.tr("Please input a valid email address@@invalid_email"),
      phone: apower.tr("Please input a valid phone number@@invalid_phone"),
      minlength(value, input) {
        return apower.tr(
          "The minimum length should be {0}@@length_must_more",
          input.attr("minLength")
        );
      },
    },

    validators: {
      required(value, input) {
        return !!value.trim();
      },

      email(value, input) {
        return /^[\w-\+]+(?:\.[\w-\+]+)*@[\w-\+]+(?:\.[\w-\+]+)+$/.test(
          value.trim()
        );
      },

      phone(value, input) {
        return /^\d{7,14}$/.test(value.trim());
      },

      minlength(value, input) {
        return value.trim().length >= input.attr("minLength") || 0;
      },
    },

    onlyValidateFirst: false,

    autoComplete: true,

    onCreated() {
      this.fields = [];
    },

    onReady() {
      this.el.find("button").on("click", (e) => e.preventDefault());
      this.el.find("input[type=submit]").on("click", this.onSubmit, this);
      this.el.find("input").on("keydown", this.onKeydown, this);
    },

    register(field) {
      this.fields.push(field);
    },

    getFieldValue(name) {
      let field = this.getField(name);
      return field.getValue();
    },

    getField(name) {
      return this.fields.find((field) => field.name === name);
    },

    setFieldValue(name, value) {
      let field = this.fields.find((field) => field.name === name);
      field.setValue(value);
    },

    onKeydown: function (e) {
      if (e.keyCode === 13) {
        this.onSubmit(e);
      }
    },

    onSubmit(e) {
      e.preventDefault();

      let invalid = this.validate();
      if (invalid) {
        this.trigger("submit", this.getData());
      }
    },

    validate() {
      let valid = true;

      if (this.onlyValidateFirst) {
        this.setUnTouched();
      }

      for (let field of this.fields) {
        let fieldValid = field.validate();
        let isFirstInValid = valid && !fieldValid;

        if (isFirstInValid) {
          field.focus();
        }

        valid = valid && fieldValid;

        if (!valid && this.onlyValidateFirst) {
          break;
        }
      }

      return valid;
    },

    validateFields(names) {
      let valid = true;

      for (let field of this.fields) {
        if (names.includes(field.name)) {
          valid = valid && field.validate();

          if (!valid && this.onlyValidateFirst) {
            break;
          }
        }
      }

      return valid;
    },

    setUnTouched() {
      for (let field of this.fields) {
        field.setUnTouched();
      }
    },

    setError(rule) {
      for (let field of this.fields) {
        if (field.hasRule(rule)) {
          field.setError(rule);
          return true;
        }
      }

      console.warn(`No field match rule "${rule}"`);

      return false;
    },

    getData(overwrite) {
      let data = {};

      for (let field of this.fields) {
        if (field.name) {
          data[field.name] = field.getValue();
        }
      }

      if (overwrite) {
        $.extend(data, overwrite);
      }

      return data;
    },

    getFormData(overwrite) {
      let formData = new FormData();

      for (let field of this.fields) {
        if (field.name) {
          formData.append(field.name, field.getValue());
        }
      }

      if (overwrite) {
        for (let name of overwrite) {
          formData.append(name, overwrite[name]);
        }
      }

      return formData;
    },
  });

  //field
  $.registerComponent("field", {
    template: `
		<div class="field" :class.field-border-through="borderThrough" :class.touched="touched" :class.invalid="errorText" :class.valid="!errorText">
			<div class="field-input-wrap"><slot></slot></div>
			<div class="field-error-text" f-html="errorText"></div>
		</div>
	`,

    messages: {},

    validators: {},

    rules: ["required"],

    //inner properties
    form: null,

    touched: false,

    errorText: "",

    validateWhen: "change",

    borderThrough: false,

    onCreated() {
      let form = this.closest("form-fields");
      if (!form) {
        throw new Error('"field" must be contained by a "form-fields"');
      }

      form.register(this);
      this.form = form;

      for (let rule of this.rules) {
        let message = this.messages[rule] || this.form.messages[rule];

        if (!message) {
          console.warn(`"message" for rule "${rule}" is not defined`);
          continue;
        }
      }
    },

    onReady() {
      this.input = this.el.find("textarea, input");
      this.input.on("input", this.onInput, this);
      this.name = this.input.attr("name");

      if (["change", "blur"].includes(this.validateWhen)) {
        this.input.on(this.validateWhen, this.validate, this);
      }

      if (this.el.find(".drop-select").length === 1) {
        this.el
          .find(".drop-select")
          .com()
          .on("change", () => {
            //先更新内部 input, 然后再校验
            $.nextTick(() => {
              this.validate();
            });
          });
      }
    },

    onInput() {
      if (this.validateWhen === "input") {
        this.validate();
      }

      //当之前有错误并且重新输入时, 会清除错误, 但是不立即检验
      //IE11 会意外触发 input
      else if (this.input.val().trim()) {
        this.errorText = "";
      }

      if (this.input.val().trim()) {
        this.el.addClass("inputted");
      } else {
        this.el.removeClass("inputted");
      }
    },

    getValue() {
      if (this.input[0].type === "file") {
        this.input[0].files[0];
      } else {
        return this.input.val();
      }
    },

    setValue(value) {
      this.input.val(value);
    },

    validate() {
      let valid = true;

      for (let rule of this.rules) {
        let message = this.messages[rule] || this.form.messages[rule];

        valid = this.isRuleValid(rule);
        if (!valid) {
          this.setErrorMessage(message);
          break;
        }
      }

      if (valid) {
        this.errorText = "";
      }

      this.setTouched();

      return valid;
    },

    isRuleValid(rule) {
      let validator = this.validators[rule] || this.form.validators[rule];

      if (validator) {
        return validator.call(this, this.input.val(), this.input);
      } else {
        return true;
      }
    },

    focus() {
      this.input.focus();
    },

    setTouched() {
      this.touched = true;
    },

    setUnTouched() {
      this.touched = false;
      this.errorText = "";
    },

    hasRule(rule) {
      return this.rules.findIndex((value) => value == rule) > -1;
    },

    setError(rule) {
      let message = this.messages[rule] || this.form.messages[rule];
      if (message) {
        this.setErrorMessage(message);
      } else {
        console.warn(`"message" for rule "${rule}" is not defined`);
      }
    },

    setErrorMessage(message) {
      this.setTouched();
      this.errorText =
        typeof message === "function"
          ? message.call(this, this.input.val(), this.input)
          : message;
    },
  });
}
